const config = {
    id: 7,
    name: "规则",
    type: 1,
    module_code: "rule",
    icon: "icon-tms-split_line",
    font_icon: "&#xe63c;",
    style_type: 1,
    link_type: 0,
    property_data: {
        text: "规则",
        position: "rb",
        right: "0",
        top: "50",
        width: "80"
    }
};

export default config;